export function downloadFromUrl(url: string): void {
  const downloadLink = document.createElement('a');
  downloadLink.href = url;
  downloadLink.click();
}

export function downloadFromB64(b64file: string, filename: string, mimeType: string): void {
  const downloadLink = document.createElement('a');
  downloadLink.href = 'data:' + mimeType + ';base64,' + b64file;
  downloadLink.download = filename;
  downloadLink.click();
}

export function downloadJSON(jsonObject: object, filename: string): void {
  const downloadLink = document.createElement('a');
  downloadLink.href = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(jsonObject));
  downloadLink.download = filename;
  downloadLink.click();
}

// TODO
export function downloadBlob(blob: Blob, filename: string, mimeType: string): void {
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  reader.onloadend = () => {
    let data = reader.result as string;
    data = data.substr(data.indexOf('base64,') + 7);
    downloadFromB64(data, filename, mimeType);
  };
}
